<id-header
  type="inera-admin"
  class="ids-hide ids-show-inera-admin"
  [hidebrand]="false"
  [unresponsive]="false"
  [fluid]="false"
  brandtext="IdP klientverktyg">
  <id-header-nav type="inera-admin" slot="header-nav">
    @for (link of navItems; track $index) {
      <id-header-nav-item type="inera-admin" [link]="true" [active]="link.active">
        <a [routerLink]="link.link.route">{{ link.link.label }}</a>
      </id-header-nav-item>
    }
  </id-header-nav>

  @if (!loggedIn) {
    <id-header-item type="inera-admin" [separatorleft]="true">
      <id-icon-user slot="icon"></id-icon-user>
      <a routerLink="login">Logga in</a>
    </id-header-item>
  } @else {
    <id-header-item type="inera-admin" [separatorleft]="true">
      <id-icon-user slot="icon"></id-icon-user>
      <a [routerLink]="['/loggedout']">Logga ut</a>
    </id-header-item>
  }

  <id-header-mobile-menu type="inera-admin" [(expanded)]="isMobileMenuOpen">
    @for (link of navItems; track $index) {
      <id-mobile-menu-item slot="menu-link">
        <a [routerLink]="[link.link.route]" (click)="isMobileMenuOpen = !isMobileMenuOpen">{{ link.link.label }}</a>
      </id-mobile-menu-item>
    }

    @if (!loggedIn) {
      <id-mobile-menu-item slot="menu-link">
        <a routerLink="login">Logga in</a>
      </id-mobile-menu-item>
    } @else {
      <id-mobile-menu-item slot="menu-link">
        <a [routerLink]="['/loggedout']">Logga ut</a>
      </id-mobile-menu-item>
    }
  </id-header-mobile-menu>
</id-header>
